import React from 'react';
import PropTypes from 'prop-types';
import { capitalize } from 'lodash';
import SpeakerCard from '../../Speakers/components/SpeakerCard';
import './TalkInformation.scss';
import { FIRST_DAY, LAST_DAY, YEAR } from '../../../constants';

export const TalkInformation = ({
  id,
  title,
  proficiency,
  liveCoding,
  summary,
  speakers,
  speakersTitle,
  technicalOrBusiness,
  video,
  room,
  conferenceDay,
  startTime,
  endTime,
  color,
  isLive,
  isStream,
  stream
}) => {
  const styles = speakers.length === 0 ? { paddingBottom: '50px' } : null;
  // const feedbackBtn =
  //   track === 'Hands-on Lab' ? (
  //     <a
  //       className="button is-large"
  //       href={`${window.location.pathname}#${location.pathname}/ff`}
  //       id="blue-button"
  //       rel="noopener noreferrer"
  //       style={{ marginTop: '50px' }}>
  //       FEEDBACK FORM
  //     </a>
  //   ) : null;

  return (
    <div key={id} className="column is-four-fifths is-12-mobile talk-detail" style={styles}>
      <div>
        <div className="talk-info-wrapper">
          <h1 className="title talk-title">{title}</h1>
          <div className="talk-room">
            <span className={`${!room ? 'is-hidden' : ''}`}>
              {' '}
              <i className={`fa fa-map-marker-alt track-${color} room-icon`} />
              {room}
            </span>
          </div>
          <div className="talk-info-rows">
            <div className={`track-indicator track-${color}-color`} />
            <div className="talk-difficulty">
              <span className={`${video ? 'video' : 'is-hidden'}`}>
                <a href={video} id="video-link" rel="noopener noreferrer" target="_blank">
                  <i className="fab fa-youtube-square" id="video-link" /> Talk video
                </a>
              </span>
              {isStream ? (
                <span className="live">
                  {isLive ? (
                    <span className="icon-text green">
                      <span className="icon pulse">
                        <i className="fas fa-circle" />
                      </span>
                      <span className="bold-text">LIVE</span>
                    </span>
                  ) : null}
                  <span className="icon-text click-link">
                    <a
                      className="video-link"
                      href={stream}
                      rel="noopener noreferrer"
                      target="_blank"
                      type="button">
                      <span className="icon click-link">
                        <i className="fab fa-youtube fa-lg" />
                      </span>
                      <span className="click-link">Stream</span>
                    </a>
                  </span>
                </span>
              ) : null}

              <span className={`${!technicalOrBusiness ? 'is-hidden' : ''}`}>
                <div className="info-bold">{capitalize(technicalOrBusiness)} talk</div>
              </span>
              <span className={`${liveCoding ? '' : 'is-hidden'}`}>
                <div className="info-bold">Includes Livecoding</div>
              </span>
              <span className={`${!proficiency ? 'is-hidden' : ''}`}>
                <div className="info-bold">Proficiency: </div> {capitalize(proficiency)}
              </span>
              <span>
                <div className="info-bold">Date: </div>
                {conferenceDay === 'day1'
                  ? `Oct ${FIRST_DAY}, ${YEAR}`
                  : `Oct ${LAST_DAY}, ${YEAR}`}
              </span>
              <span>
                <div className="info-bold">Time:</div>
                {startTime} - {endTime}
              </span>
            </div>
          </div>
        </div>
        <div className="underline" />
        <p className="description">{summary}</p>
        {/* {feedbackBtn} */}
        <div className="underline" />
      </div>
      {speakers.length > 0 ? (
        <div className="speakers-part">
          <h4 className="title talk-title">{speakersTitle}</h4>
          <div className="columns is-multiline">
            {speakers &&
              speakers.map((speaker, i) => {
                const speakerObj =
                  typeof speaker === 'object'
                    ? { ...speaker }
                    : { id: `unknown${i}`, name: speaker };
                return (
                  <SpeakerCard
                    key={speakerObj.id}
                    company={speakerObj.company || ''}
                    country={speakerObj.country || ''}
                    id={speakerObj.id}
                    name={speakerObj.name || ''}
                    photo={speakerObj.photo || ''}
                  />
                );
              })}
          </div>
        </div>
      ) : null}
    </div>
  );
};

TalkInformation.defaultProps = {
  speakersTitle: 'Speakers',
  room: '',
  conferenceDay: '',
  startTime: '',
  endTime: '',
  color: '',
  stream: ''
};

TalkInformation.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  conferenceDay: PropTypes.string,
  endTime: PropTypes.string,
  id: PropTypes.string.isRequired,
  isLive: PropTypes.bool.isRequired,
  isStream: PropTypes.bool.isRequired,
  liveCoding: PropTypes.bool.isRequired,
  proficiency: PropTypes.string.isRequired,
  room: PropTypes.string,
  speakers: PropTypes.arrayOf(PropTypes.any).isRequired,
  speakersTitle: PropTypes.string,
  startTime: PropTypes.string,
  stream: PropTypes.string,
  summary: PropTypes.string.isRequired,
  technicalOrBusiness: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  video: PropTypes.string.isRequired
};

export default TalkInformation;
